export default __webpack_public_path__ + "static/media/home4.c5231e8a.png";